import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { exhaustMap, map } from "rxjs/operators";
import { PropertyService } from "../services/property.service";
import {
  loadProperties,
  loadPropertyCharts,
  propertiesLoaded,
  propertyChartsLoaded,
} from "./properties.action";

@Injectable()
export class PropertiesEffects {
  loadProperties$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadProperties),
      exhaustMap((actions) =>
        this.propertiesService.getPropertyList()
          .pipe(
            map((response) => propertiesLoaded({ properties: response.data }))
          )
      )
    )
  );

  loadPropertyCharts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadPropertyCharts),
      exhaustMap((action) =>
        this.propertiesService.getPropertyCharts(action.propertyId)
          .pipe(
            map((response) => propertyChartsLoaded({ propertyId: action.propertyId, data: response.data }))
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private propertiesService: PropertyService
  ) {}
}
